import React, { useState } from "react";

function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");
    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => null);
      if (!res.ok || !(data && data.ok === true)) {
        const message = (data && (data.error || data.detail)) || "Failed to send";
        throw new Error(message);
      }
      setStatus("success");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setStatus(`error:${err.message || "Failed to send message"}`);
    } finally {
      setLoading(false);
    }
  };

  const renderAlert = () => {
    if (!status) return null;
    if (status.startsWith("success")) return (
      <div className="contact-alert success">Thank you! Your message has been sent.</div>
    );
    if (status.startsWith("error:")) return (
      <div className="contact-alert error">{status.replace("error:", "")}</div>
    );
    return null;
  };

  return (
    <section className="contact-section">
      <div className="contact-card">
        <h2 className="contact-title">Contact Me</h2>
        <p className="contact-subtitle">I'd love to hear from you! Fill out the form below and I'll get back to you soon.</p>
        <form onSubmit={handleSubmit} className="contact-form" autoComplete="off">
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              className="form-control"
              value={form.name}
              onChange={handleChange}
              required
              placeholder="Your Name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-control"
              value={form.email}
              onChange={handleChange}
              required
              placeholder="you@example.com"
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              className="form-control"
              value={form.message}
              onChange={handleChange}
              required
              placeholder="Type your message..."
              rows={5}
            />
          </div>
          <button type="submit" className="contact-btn" disabled={loading}>
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
        {renderAlert()}
      </div>
    </section>
  );
}

export default Contact;
